import { Container } from './Container';
import { Label } from './Label';
import { Error } from './Error';

export default {
  Container,
  Label,
  Error,
};
